export const isServer = typeof window === 'undefined';

//# sourceMappingURL=isServer.js.map